// Auth transitions clear telemetry without importing hospital UI into login.
const cleanups = new Set<() => void>();
export const registerReviewActivityCleanup = (cleanup: () => void) => {
    cleanups.add(cleanup);
    return () => {
        cleanups.delete(cleanup);
    };
};
export const clearReviewActivitySession = () => {
    for (const cleanup of cleanups) cleanup();
};
